import SalesComponent from './components/SalesComponent';
import mutations from './containers/graphql';
import { compose } from 'ramda';

export default compose(mutations)(SalesComponent);
